

<template>
  <p class="mt-5">
    <span v-if="session.is_cancelled" :href="goToUrl(session)"
          class="inline-flex items-center px-3 py-0.5
rounded-full text-sm font-medium bg-yellow-100 text-yellow-800"
          target="target-zoom">
      <svg class="-ml-1 mr-1.5 h-2 w-2 text-yellow-400"
           fill="currentColor" viewBox="0 0 8 8">
        <circle cx="4" cy="4" r="3"/>
      </svg>
      CANCELLED
    </span>
    <template v-else-if="(!session.is_cancelled) && session.hasPhysical && session.location">
      <p><a :href="`/session-locations/${session.location.id}`">Location: {{session.location?.name ?? 'unnamed location'}}
        <span v-if="session.location?.building">
          ({{session.location?.building?.name}})
        </span>

      </a>

      </p>
    </template>
  </p>
</template>

<script>

export default {
  name: "SessionLiveLocation",
  props:
      {
        session: {
          type: Object,
          required: true
        },
      }
}

</script>

<style scoped>

.delimiter {
  color: #ccc;
}

.pr {
  color: #666;
}

span.hide-last-delimiter:last-child span.delimiter {
  display: none;
}

.session-wrapping {
  background-color: rgba(0, 0, 0, 0.01);
  border: 1px solid rgba(0, 0, 0, 0.03);
}

.session-wrapping a {
  color: rgb(79, 70, 229);
}

.session-wrapping a.text-white {
  color: #FFF;
}

</style>
